import React, { useState,useEffect } from 'react';
import { ProcessErrors } from '../Utilities/ErrorBox';
import { Loading } from '../Utilities/Loading';
import { APIGet, APIPost, APIRedirect, getEnvironment} from '../API/APIRequest';
import { GetConfiguration, GetCurrentBrand } from '../Configuration/ConfigurationManager';
import { GetADToken, SaveADToken, RefreshADToken, GetADRefTokenLocal, RemoveADToken, RemoveADRefToken, SaveADRefToken } from '../Utilities/TokenManager'
import { GetCookieName, GetCookieValue, AuthenticateWithServerCookie, DeleteCookie, SaveCookie} from '../Utilities/ADFECookie'
const AuthContext = React.createContext()

function useProvideMiddlewareAuth() {
   
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [errors, setErrors] = useState([]);
    const [webAuth, setWebAuth] = useState(null)
    const [environment, setEnvironment] = useState(getEnvironment());
    const [currentAction, setCurrentAction] = useState([]);
    const [returnUrl, setReturnUrl] = useState(null);



    const getCurrentBrand=()=>{
        GetCurrentBrand(environment).then((brand) => {
            if (brand?.returnurl) { 
                sessionStorage.setItem("ReturnUrl", brand.returnurl);
                sessionStorage.setItem("CookieDomain", brand.cookiedomain);
                setReturnUrl(brand.returnurl);
            }
            //resolve(returnUrl);
        }).
        catch((error) => {
            //reject(error);
        })
    
     }
    
    //only will run in case of no cookie domain and no returnUrl
    useEffect(()=>{
     if(!sessionStorage.getItem("CookieDomain")){
        getCurrentBrand();
        }

      }, [])

    const params = new Proxy(new URLSearchParams(window.location.search),
        {
            get: (searchParams, props) => searchParams.get(props),
        });

   
    
    const ReturnUrl = () => {
        
        let params = (new URL(document.location)).searchParams;
        let retUrl = params.get("ReturnUrl");
        if (retUrl){
            setReturnUrl(retUrl);
            return retUrl;

            } 

        if (!returnUrl ) {
        //return new Promise((resolve, reject) => {
        let params = (new URL(document.location)).searchParams;
        let retUrl =params.get("ReturnUrl");
           
            if (!retUrl) {
                retUrl = document.referrer;
            }
            if (!retUrl) {
                retUrl = sessionStorage.getItem("ReturnUrl");
            }
            if (retUrl) {
                setReturnUrl(retUrl);
                //resolve(returnUrl);
            }
            if (!retUrl) {
                getCurrentBrand();
            }

        }
        return returnUrl;
        //})
    }

    const ClearUserData = () => {
        RemoveADToken();
        setUserData(null);
    }

    const ReloadUserData = () => {       
        getUserToken().then((userToken) => {
            currentAction.pop();
            setUserData(userToken);      
        }).catch((error) => {
            errors.push(ProcessErrors("error.unexpected"));
        });
    }


    const AuthenticateWithCookie = () => {
        return new Promise(async(resolve, reject) => { 
            try{
            let user = await AuthenticateWithServerCookie();

            if (user) {
                let userToken = {
                    "name": user.userfullname,
                    "token": user.userToken,
                    "partyid": user.partyid,
                    "username": user.username,
                    "isactivated": user.isactivated
                };
                SaveADToken(userToken);
                resolve(userToken);
            }
            else{
                resolve(null);
            }
        }catch(error){
            reject(error);
        }});

    }
  
    const getUserToken = () => {
        return new Promise(async(resolve, reject) => {
            currentAction.push("getusertoken");
            let refToken = params.ref;
            let userToken = GetADToken();   

          

            //if (userToken && !refToken)
            //{
            //    GetCookieName().then((cookieName) => {
           
            //        var cookieValue = GetCookieValue(cookieName);
       
            //        if (!cookieValue) {
            //            RemoveADToken();
            //            setUserData(null);
            //            resolve(null);
            //        }
            //    });
            //}
                                
            if (userToken?.token) {
                resolve(userToken);
                return;
            }

            // PADD-3916 (loop fix): resolve the session from exactly ONE source and resolve the
            // promise exactly once. The previous structure attached the anonymous `else` to the
            // ref branch and shadowed `userToken` inside the cookie branch, so a no-token/no-ref
            // load (every refresh of a questionnaire form, where the cached token is wiped on
            // load and there is no ?ref=) fell through to `else` and resolved {anon:true} even
            // while AuthenticateWithCookie() was concurrently succeeding — bouncing a logged-in
            // user to the middleware login on every refresh (the redirect loop).
            if (!refToken) {
                // No ref token: the durable session lives in the server cookie. Re-derive it.
                const cookieToken = await AuthenticateWithCookie().catch(() => null);
                if (cookieToken?.token) {
                    resolve(cookieToken);
                    return;
                }
            } else {
                // Return-from-login leg: exchange the one-time ref token for a session.
                const result = await APIGet({
                    "controller": "auth",
                    "action": "getuserbyreftoken",
                    "identifier": refToken
                }).catch(() => null);

                const user = result?.data?.user;
                if (user) {
                    const refUserToken = {
                        "name": user.userfullname,
                        "token": user.userToken,
                        "partyid": user.partyid,
                        "username": user.username,
                        "isactivated": user.isactivated
                    };
                    SaveADToken(refUserToken);
                    resolve(refUserToken);
                    return;
                }

                // Ref token could not be exchanged (one-time token already consumed, e.g. on a
                // refresh that still carries a stale ?ref=): fall back to the server cookie
                // before giving up, so an already-authenticated user is not sent back to login.
                const cookieToken = await AuthenticateWithCookie().catch(() => null);
                if (cookieToken?.token) {
                    resolve(cookieToken);
                    return;
                }
            }

            // No cached token, no valid cookie, no usable ref token -> genuinely anonymous.
            resolve({ "anon": true });
        });

    }

    const GetADRefToken = () => {
        let refToken = params.refToken;
        if (!refToken) {
            refToken = GetADRefTokenLocal();
        }
        return refToken;
    }
  
   
    if (currentAction.length === 0 && !userData && isLoading) {
        if(window.location){
            const searchParams = new URLSearchParams(window.location.search);
            const discountApplied = searchParams.get("discountApplied");   //check for discount flow, to prevent removal of adToken

            let url=window.location.pathname; 
            let urlParams=  url.split("/");
            // PADD-3916: questionnaireform is included so the form behaves like checkout —
            // the cached adtoken is wiped on load, forcing auth to be re-derived from the live
            // server cookie instead of trusting a stale sessionStorage token (the sign-out bug).
            // A fresh ?ref= login still authenticates via the ref branch in getUserToken, and
            // CaptureForms' one-shot ReloadUserData retry absorbs the return-from-login race so
            // this no longer causes the login redirect loop.
            if(urlParams.includes("checkout") || urlParams.includes("ManageRecipients") || urlParams.includes("questionnaireform")){
               if(!discountApplied){
                 RemoveADToken();
               }
               
            }
        }
        if (!currentAction.includes("getusertoken")) {
            getUserToken().then((userToken) => {
                currentAction.pop();
             
                setUserData(userToken);
                setIsLoading(false);

            }).catch((error) => {
               
                errors.push(ProcessErrors("error.unexpected"));
                setIsLoading(false);
            });
        }
    }
    else {
        var sessionToken = GetADToken()
        if (!userData && sessionToken) {
            setUserData(sessionToken);
            
        }
        
    }
    return {
        environment,
        userData,
        isLoading,
        setErrors,
        errors,
        ReturnUrl,
        GetADRefToken,
        ClearUserData,
        ReloadUserData,
    }
}

function AuthenticationProvider(props) {
    
    var auth = useProvideMiddlewareAuth();
    
    if (auth.isLoading) {
        return (<Loading loading={true} class={"center-column"} />);
    }
    else {
        return (<AuthContext.Provider value={auth} {...props} />)
    }
}


const useAuth = () => {
    return React.useContext(AuthContext);
}
export {AuthenticationProvider, useAuth}